<template style="height: 100%;">
  <div class="content-body">
    <div v-if="IsInit" class="paper-content">
      <div class="ct-user">
        <div class="paper-left-p">
          <el-row><div class="paper-tip">请选择被试对象</div></el-row>
          <el-row class="paper-item">
            <div class="item-lable">账号：</div>
            <div class="item-text">
              <el-input
                v-model="User.UserID"
                placeholder="选择用户"
                class="input-text"
                disabled
              ></el-input>
            </div>
          </el-row>
          <el-row class="paper-item">
            <div class="item-lable">年龄：</div>
            <div class="item-text">
              <el-input
                v-model="User.Age"
                placeholder="输入年龄"
                class="input-text"
                @blur="InputCheck(User.Age, 'age')"
              ></el-input>
            </div>
          </el-row>

          <el-row class="buttom-row">
            <el-button type="primary" @click="dialogUser = true">
              选择被试者
            </el-button>
          </el-row>
        </div>
      </div>
      <div class="ct-paper">
        <div class="paper-right-p">
          <el-row><div class="paper-tip">请输入四舍五入之后的整数</div></el-row>
          <el-row v-if="this.User.Age < 16" class="paper-item">
            <div class="item-lable">定向经历粗分：</div>
            <div class="item-text">
              <el-input
                v-model="T000"
                placeholder="请输入值"
                class="input-text"
                @change="CheckRange('T000')"
              ></el-input>
            </div>
          </el-row>

          <el-row v-for="item in PaperItem" :key="item.Key" class="paper-item">
            <div class="item-lable">{{ item.Name }}</div>
            <div class="item-text">
              <el-input
                v-model="item.Value"
                placeholder="请输入值"
                class="input-text"
                @change="CheckRange(item.Key)"
                @blur="InputCheck(item.Value, 'paper')"
              ></el-input>
            </div>
          </el-row>
          <el-row class="buttom-row">
            <el-button type="primary" @click="Submit">
              提交
            </el-button>
          </el-row>
        </div>
      </div>
      <el-dialog
        title="受试者列表"
        :visible.sync="dialogUser"
        :close-on-click-modal="false"
      >
        <el-table
          :data="UserList"
          stripe
          ref="singleTable"
          highlight-current-row
          @current-change="handleCurrentChange"
          style="width: 100%;"
        >
          <el-table-column
            property="Index"
            label="序号"
            width="200"
            :center="true"
          ></el-table-column>
          <el-table-column
            property="UserID"
            label="账号"
            width="200"
            :center="true"
          ></el-table-column>
          <el-table-column
            property="Name"
            label="姓名"
            width="200"
          ></el-table-column>
          <el-table-column
            property="Sex"
            label="性别"
            width="169"
          ></el-table-column>
          <el-table-column
            property="Birthday"
            label="出生日期"
          ></el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next"
          :page-size="10"
          :total="AllCount"
          @current-change="current_change"
        ></el-pagination>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="SelectUser"
            :disabled="
              SelectObj == null || SelectObj.UserID == '' ? true : false
            "
          >
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
    <div v-if="!IsInit" class="data-load">
      <div class="data-load-tip">
        <img src="../../assets/loadingbar.gif" alt="load" />
        <div>拼命加载中...</div>
      </div>
    </div>

    <el-dialog
      :title="PaperInfo.PublishSubject + '指导语'"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{ PaperInfo.StartGuidelines }}</span>
    </el-dialog>

    <el-dialog
      :title="PaperInfo.PublishSubject + '指导语'"
      :visible.sync="dialogVisible2"
      width="30%"
    >
      <span>{{ PaperInfo.FinishGuidelines }}</span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      IsInit: false,
      PaperID: '',
      IsGuide: false,
      T000: 0,

      UserInfo: {
        TesterID: '',
        Account: '',
        Name: '',
      },
      PaperItem: [
        { Key: 'T001', Name: '1=>100粗分：', MaxValue: 29, Value: '' },
        { Key: 'T002', Name: '100=>1粗分：', MaxValue: 28, Value: '' },
        { Key: 'T003', Name: '累加粗分：', MaxValue: 18, Value: '' },
        { Key: 'T004', Name: '记图粗分：', MaxValue: 22, Value: '' },
        { Key: 'T005', Name: '再认粗分：', MaxValue: 26, Value: '' },
        { Key: 'T006', Name: '联想粗分：', MaxValue: 80, Value: '' },
        { Key: 'T007', Name: '触摸粗分：', MaxValue: 80, Value: '' },
        { Key: 'T008', Name: '再生粗分：', MaxValue: 80, Value: '' },
        { Key: 'T009', Name: '理解粗分：', MaxValue: 80, Value: '' },
        { Key: 'T0010', Name: '背数粗分：', MaxValue: 80, Value: '' },
      ],
      UserList: [],
      dialogUser: false,
      SelectObj: null,
      User: {
        UserID: '',
        Account: '',
        Name: '',
        Sex: '',
        Birthday: '',
      },
      SourceNo: '0',
      StartDateTime: '',
      EndDateTime: '',
      PaperInfo: {},
      PageInfo: {
        CurrentIndex: 0,
        PageSize: 10,
        PageIndex: 0,
        TotleCount: 0,
        TotlePageCount: 0,
      },
      AllCount: -1,
    }
  },
  mounted: function () {
    this.PaperID = this.$route.query.PaperID
    this.InitPaper()
    this.GetUserList()
  },
  methods: {
    InitPaper() {
      let _this = this
      this.$Http_Post('Paper/GetPaperInfo', {
        SourceNo: _this.SourceNo,
        PaperID: _this.PaperID,
        UserID: '',
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.PaperInfo = res.Data
          _this.IsInit = true
          _this.StartDateTime = this.Global.getCurrentTime()
          if (_this.PaperInfo.StartGuidelines) {
            _this.dialogVisible = true
          } else {
            _this.dialogVisible = false
          }
        } else {
          this.$message({
            type: 'error',
            message: '初始化量表失败',
          })
        }
      })
    },
    StartPaperTest() {
      this.IsGuide = true
      this.StartDateTime = this.Global.getCurrentTime()
    },
    CheckRange(keys) {
      if (keys == 'T000') {
        var maxScore = parseInt(this.User.Age) > 16 ? 0 : 10
        //输入的分数=
        var tempscore = this.T000
        if (parseInt(tempscore) > parseInt(maxScore)) {
          this.T000 = 0

          this.$message({
            type: 'warning',
            message: '定向经历粗分大于限定最大值：' + maxScore,
          })
        }
      } else {
        //因子简称
        var arrScaleName = new Array(
          'T001',
          'T002',
          'T003',
          'T004',
          'T005',
          'T006',
          'T007',
          'T008',
          'T009',
          'T0010',
        )
        //因子中文对照
        var arrScaleChinaName = new Array(
          '1=>100粗分',
          '100=>1粗分',
          '累加粗分',
          '记图粗分',
          '再认粗分',
          '再生粗分',
          '联想粗分',
          '触摸粗分',
          '理解粗分',
          '背数粗分',
        )
        //成人最高分
        var arrScaleMaxScoreAduit = [81, 293, 139, 20, 16, 14, 21, 522, 29, 20]
        //儿童最高分
        var arrScaleMaxScoreChild = [82, 594, 338, 18, 16, 14, 21, 593, 25, 20]
        //得到因子指数
        var index = arrScaleName.indexOf(keys)
        //得到最高分
        var maxScore =
          parseInt(this.User.Age) > 16
            ? arrScaleMaxScoreAduit[index]
            : arrScaleMaxScoreChild[index]
        //输入的分数=
        var tempscore = null
        var theindex = 0
        for (let i = 0; i < this.PaperItem.length; i++) {
          if (this.PaperItem[i].Key == keys) {
            theindex = i
            tempscore = this.PaperItem[i].Value
          }
        }

        //“理解”项的值不能以“.结尾”
        if (keys == 'T009') {
          //先把非数字的都替换掉，除了数字和.
          tempscore = tempscore.replace(/[^\d.]/g, '')
          //必须保证第一个为数字而不是.
          tempscore = tempscore.replace(/^\./g, '')
          //保证只有出现一个.而没有多个.
          tempscore = tempscore.replace(/\.{2,}/g, '.')
          //保证.只出现一次，而不能出现两次以上
          tempscore = tempscore
            .replace('.', '$#$')
            .replace(/\./g, '')
            .replace('$#$', '.')

          var indexstr = tempscore.indexOf('.')
          if (indexstr != -1) {
            //只保留一位小数
            tempscore = tempscore.substring(0, parseInt(indexstr) + 2)
            //小数点后面只能输入5
            if (
              tempscore.substring(tempscore.length - 1, tempscore.length) != 5
            ) {
              tempscore = tempscore.substring(0, parseInt(indexstr) + 1)
              new Vue().$message.closeAll()
              this.$message({
                type: 'warning',
                message: '小数点后面只能输入5',
              })
            }
          }
          if (tempscore.charAt(tempscore.length - 1) == '.') {
            tempscore = tempscore.substring(0, tempscore.length - 1)
          }
          this.PaperItem[8].Value = tempscore
        }
        //判断是否大于最高分

        if (parseInt(tempscore) > parseInt(maxScore)) {
          this.PaperItem[index].Value = ''

          this.$message({
            type: 'warning',
            message: arrScaleChinaName[index] + '大于限定最大值：' + maxScore,
          })
        }
      }
    },
    InputCheck(val, obj) {
      if (val != '') {
        this.$message.closeAll()
        if (!this.User.UserID || this.User.UserID == '') {
          this.$message({
            type: 'warning',
            message: '请选择被试者',
          })
        } else {
          if (obj == 'age') {
          }
        }
      }
    },
    Submit: function () {
      var dataInfo = '' //【"1=>100粗分", "100=>1粗分", "累加粗分", "记图粗分", "再认粗分", "再生粗分", "联想粗分", "触摸粗分", "理解粗分", "背数粗分"】
      let state = true
      var basicInfo = null
      if (this.User.UserID === '') {
        this.$message.closeAll()
        this.$message({
          type: 'warning',
          message: '请选择被试者',
        })
        state = false
        return
      } else {
        let count = 0
        for (let i = 0; i < this.PaperItem.length; i++) {
          if (this.PaperItem[i].Value != '') {
            count++
          }
        }

        if (this.User.Age > 16) {
          if (count < 9) {
            this.$message.closeAll()
            this.$message({
              type: 'warning',
              message: '成人韦氏最少输入九项粗分！',
            })
            state = false
            return
          }
        } else if (this.User.Age > 100) {
          this.$message({
            type: 'warning',
            message: '年龄不能大于100岁',
          })
          this.User.Age = ''
          state = false
          return
        } else {
          if (count < 8) {
            this.$message.closeAll()
            this.$message({
              type: 'warning',
              message: '儿童韦氏最少输入八项粗分！',
            })
            state = false
            return
          }
        }
      }
      for (let i = 0; i < this.PaperItem.length; i++) {
        if (this.PaperItem[i].value != '') {
          dataInfo += this.PaperItem[i].value + ','
        } else {
          dataInfo += '0' + ','
        }
      }
      //basicInfo = this.Accountis.User + "," + this.User.Age;
      //dataInfo = dataInfo.substring(0, dataInfo.length - 1);

      if (state) {
        this.EndDateTime = this.Global.getCurrentTime()
        let tmpRst =
          this.User.UserID + ',' + this.User.Age + ',' + this.T000 + ','
        this.PaperItem.forEach((item, idx) => {
          tmpRst += item.Value + ','
        })
        tmpRst = tmpRst.substring(0, tmpRst.length - 1)

        let result = {
          PaperResultID: '',
          SourceNo: this.SourceNo,
          SourceFlg: 1,
          PaperID: this.PaperID,
          PaperTestProgress: 0,
          UserID: this.User.UserID,
          StartDateTime: this.StartDateTime,
          EndDateTime: this.EndDateTime,
          TmpResult: tmpRst,
          IsSubmit: 1,
          Creator: this.User.UserID,
          SourceFlg: this.$route.query.type,
        }

        this.$Http_Post('Paper/Submit', { data: result }).then((res) => {
          this.$message.closeAll()
          if (res.Code == 200 || res.Code == 0) {
            this.$router.go(-1)
            this.$message({
              type: 'success',
              message: res.Message,
            })
          } else {
            this.$message({
              type: 'error',
              message: '量表提交失败',
            })
          }
        })
      }
    },
    handleCurrentChange: function (val) {
      this.SelectObj = val
    },
    current_change: function (currentPage) {
      this.PageInfo.PageIndex = currentPage
      this.GetUserList()
    },
    SelectUser: function () {
      this.dialogUser = false
      this.User = this.SelectObj
    },
    GetUserList() {
      this.$Http_Post('User/GetAllUserList', {
        pageSize: this.PageInfo.PageSize,
        pageIndex: this.PageInfo.PageIndex,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.UserList = res.Data.UserList
          this.AllCount = res.Data.AllCount
        }
      })
    },
    NextPage: function () {},
  },
}
</script>

<style>
.content-body .data-load {
  width: 100%;
  height: 100%;
  position: relative;
}

.content-body h2 {
  line-height: 50px;
  height: 50px;
  text-align: center;
}
.content-body .data-load-tip {
  width: 214px;
  height: 80px;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  line-height: 30px;
  color: cornflowerblue;
}

.content-body {
  border: 1px solid #e4e7ed;
  background-color: #f6fafb;
  height: calc(100% - 35px);
  padding: 20px;
  border-radius: 5px;
}

.content-body .paper-content {
  width: 100%;
  height: 100%;
}

.content-body .paper-guide {
  width: 50%;
  text-align: left;
  margin: 0 auto;
}

.content-body .ct-user {
  width: calc(50% - 10px);
  height: 100%;
  float: left;
  background-color: #f8f7f2;
  position: relative;
}

.content-body .ct-paper {
  width: calc(50% - 10px);
  height: 100%;
  float: right;
  background-color: #f8f7f2;
  position: relative;
}

.content-body .paper-tip {
  text-align: center;
  height: 50px;
  line-height: 50px;
  color: red;
}

.content-body .paper-left-p {
  width: 100%;
  position: absolute;
  top: 50%;
  margin-top: -112px;
}

.content-body .paper-right-p {
  width: 100%;
  position: absolute;
  top: 50%;
  margin-top: -352px;
}

.content-body .paper-item {
  padding: 5px 10px;
  line-height: 40px;
  margin-top: 0px;
}

.content-body .item-lable {
  padding-right: 20px;
  width: calc(50% - 10px);
  text-align: right;
  float: left;
}

.content-body .item-text {
  width: calc(50% - 20px);
  float: right;
}

.content-body .input-text {
  width: 70% !important;
}

.content-body .item-text input {
  width: 100%;
}

.content-body .buttom-row {
  text-align: center;
  margin-top: 10px;
}

.content-body .current-row {
  background-color: #92bfed !important;
}

.content-body .el-row {
  text-align: center;
  margin-bottom: 0px !important;
}

.content-body .el-table__body tr.current-row > td,
.content-body
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped.current-row
  td {
  background-color: #98c7fb !important;
  color: white;
}
</style>
